import { Injectable, computed, signal } from '@angular/core';

// Minimum delay (ms) before the full-screen loader appears.
// Requests that complete faster than this are invisible to the user,
// eliminating flickering on fast search/autocomplete responses.
const SHOW_DELAY_MS = 300;

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private activeRequests = signal(0);
  private _visible = signal(false);
  private showTimerId: ReturnType<typeof setTimeout> | null = null;

  readonly isLoading = computed(() => this._visible());

  show(): void {
    this.activeRequests.update((n) => n + 1);
    if (this.showTimerId === null && !this._visible()) {
      this.showTimerId = setTimeout(() => {
        this.showTimerId = null;
        if (this.activeRequests() > 0) {
          this._visible.set(true);
        }
      }, SHOW_DELAY_MS);
    }
  }

  hide(): void {
    this.activeRequests.update((n) => Math.max(0, n - 1));
    if (this.activeRequests() === 0) {
      if (this.showTimerId !== null) {
        clearTimeout(this.showTimerId);
        this.showTimerId = null;
      }
      this._visible.set(false);
    }
  }
}
